import React, { useMemo } from 'react'

import { Typography } from '@material-ui/core'

import getFormattedAmountAndDuration from '../../helpers/tariff.helpers'

import { TimeUnit } from '~/basket/model/common/duration.model'
import { Price } from '~/basket/model/common/price.model'
import { formatPriceStr } from '~/prices/prices.helpers'

export default function TariffPriceAndDuration({
  price: { value, duration },
  className,
}: {
  price: Price
  className: string
}) {
  const amountAndDuration = useMemo(
    () => getFormattedAmountAndDuration(duration.amount, duration.unit || TimeUnit.MONTH),
    [duration],
  )

  const formattedPrice = formatPriceStr(value)

  return (
    <div className={className}>
      <Typography component="span" variant="caption" color="textSecondary">
        {formattedPrice} €/mes
      </Typography>
      <Typography component="span" variant="caption" color="textSecondary" className="regular">
        {amountAndDuration}
      </Typography>
    </div>
  )
}
